import { getFramework } from '@/framework';
import { isHotKeyPress } from '@/utils/event-kit';
import { LayerType } from '@/version-types';
import { CoreAPI } from '../../core';
import { HoverExtendType, IHoverExtendArgs } from '../type';

/** 图层hover扩展 */
export class HoverExtend {
    constructor(private readonly identity: string) {}

    /** hover扩展事件 */
    private eventName = 'gs-hover-extend';

    /** hover扩展数据 */
    private data: IHoverExtendArgs | null = null;

    private target: HTMLDivElement | null = null;

    private handle: ((e: MouseEvent) => void) | null = null;

    /** 设置hover扩展 */
    set(args: IHoverExtendArgs) {
        this.data = args;
        this.emitChange();
    }

    /** 获取hover扩展 */
    get() {
        return this.data;
    }

    /** 应用 */
    apply(layerId: string) {
        if (!layerId || !this.data) return;
        const data = this.data;
        if (!isHotKeyPress()) {
            this.data = null;
            this.emitChange();
        }
        if (data.layerId !== layerId) {
            data.apply(layerId);
        }
        this.target = null;
    }

    /** 监听hover扩展 */
    onChange(callback: (data: IHoverExtendArgs | null) => void, weight = 0) {
        return CoreAPI(this.identity).events.on(this.eventName, callback, weight);
    }

    /** 销毁 */
    destroy() {
        this.data = null;
        this.emitChange();
        this.target = null;
    }

    /** 滑过样式 */
    hover(target: HTMLDivElement, layerType?: LayerType) {
        this.clearCursor();
        this.target = target;
        if (this.targetLayerType && this.target && layerType && layerType !== this.targetLayerType) {
            this.target.style.cursor = 'not-allowed';
            return;
        }
        if (layerType && layerType === this.targetLayerType && this.data?.cursorTip) {
            this.handle = (e) => {
                if (this.data?.cursorTip) {
                    const framework = getFramework(this.identity);
                    framework.operate.cursorTip.set({
                        type: 'custom',
                        x: e.x,
                        y: e.y,
                        txt: this.data?.cursorTip,
                    });
                }
            };
            document.addEventListener('mousemove', this.handle);
        }
        this.setCursor();
    }

    private get targetLayerType() {
        if (this.data?.type === HoverExtendType.IMAGE_BRUSH) return LayerType.IMAGE_LAYER;
        if (this.data?.type === HoverExtendType.TEXT_BRUSH) return LayerType.TEXT_LAYER;
        return null;
    }

    private setCursor() {
        if (this.target) {
            if (this.data?.cursor) {
                this.target.style.cursor = `var(${this.data?.cursor})`;
            }
        }
    }

    clearCursor() {
        if (this.target) {
            this.target.style.cursor = '';
        }
        if (this.handle) {
            const framework = getFramework(this.identity);
            framework.operate.cursorTip.clear();
            document.removeEventListener('mousemove', this.handle);
            this.handle = null;
        }
    }

    private emitChange() {
        const data = this.data;
        if (!data) {
            this.clearCursor();
        }
        CoreAPI(this.identity).events.emit(this.eventName, data);
    }
}
